"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignOccupancyRequestDto = exports.CampaignOccupancyDisplayDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CampaignOccupancyDisplayDto {
    displayId;
    timeZone;
}
exports.CampaignOccupancyDisplayDto = CampaignOccupancyDisplayDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CampaignOccupancyDisplayDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsTimeZone)(),
    __metadata("design:type", String)
], CampaignOccupancyDisplayDto.prototype, "timeZone", void 0);
class CampaignOccupancyRequestDto {
    displays;
    dateKeys;
}
exports.CampaignOccupancyRequestDto = CampaignOccupancyRequestDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(1500),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CampaignOccupancyDisplayDto),
    __metadata("design:type", Array)
], CampaignOccupancyRequestDto.prototype, "displays", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(367),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, { each: true }),
    __metadata("design:type", Array)
], CampaignOccupancyRequestDto.prototype, "dateKeys", void 0);
